import { render } from "./MojeAnkete.vue?vue&type=template&id=2f8907ef&scoped=true"
import script from "./MojeAnkete.vue?vue&type=script&lang=js"
export * from "./MojeAnkete.vue?vue&type=script&lang=js"

import "./MojeAnkete.vue?vue&type=style&index=0&id=2f8907ef&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f8907ef"]])

export default __exports__